export default __webpack_public_path__ + "static/application-audit-38c73b75e689339ba6cddd0e1a63ea11.jpg";